module.exports = __webpack_public_path__ + "img/music.07613e22.png";